import React, { ReactNode, Suspense } from "react";
import styles from "./Layout.module.scss";
import { Outlet } from "react-router-dom";

interface Props {
    headerSlot: React.ReactNode;
    sidebarSlot: React.ReactNode;
    children?: React.ReactNode;
}

export const Layout = ({ headerSlot, sidebarSlot, children }: Props) => {
    return (
        <Suspense>
            <div className={styles.layout}>
                {headerSlot}
                {sidebarSlot}
                {children}
            </div>
        </Suspense>
    );
};